import { render, staticRenderFns } from "./BackTopBar.vue?vue&type=template&id=3df8e652&scoped=true&"
import script from "./BackTopBar.vue?vue&type=script&lang=js&"
export * from "./BackTopBar.vue?vue&type=script&lang=js&"
import style0 from "./BackTopBar.vue?vue&type=style&index=0&id=3df8e652&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df8e652",
  null
  
)

export default component.exports